<template>
  <div>
  <Modal :title="limitMonthTimes" v-model="visible" width="750" v-drag-modal :mask-closable="false">
    <Form ref="modalForm" class="form"
          :model="formData" :rules="formRule"
          :label-width="80">
      <Row>
        <i-col :span="22">
          <Form-item label="学生信息">
            <label>{{ formData.uid }}  - {{ formData.mobile }} - {{ formData.nickname }}</label>
          </Form-item>
        </i-col>
        <i-col :span="12" v-show="false">
          <Form-item label="教室" prop="schoolId" >
            <Select v-model.number="formData.schoolId" transfer>
              <Option v-for="item in $constant.schoolEnums"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :span="12">
          <Form-item label="Level" prop="levelId">
            <Select filterable v-model.number="formData.levelId" transfer>
              <Option v-for="item in bookMaterialLevelList"
                      :value="item.id" :key="item.id">{{ item.title }}(版本{{item.materialVersion}})
              </Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :span="20">
          <Form-item label="老师" prop="tchId">
            <label>
              <TeacherSelect :category="[1, 2]" v-model="formData.tchId" :uid="formData.uid" :isCanBound="1" @change-select="onTchSelect"></TeacherSelect>
            </label>
          </Form-item>
        </i-col>
        <i-col :span="22">
          <Form-item label="选择时间" prop="workTime">
            <Row :gutter="8">
              <i-col :span="4">
                <Form-item prop="week">
                  <Select placeholder="星期" v-model="formData.week" transfer @on-change="onChangeWeek">
                    <Option v-for="item in $constant.week"
                            :value="item.code" :key="item.code">{{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </i-col>
              <i-col :span="6">
                <Form-item prop="startTime">
                  <Time-picker format="HH:mm" placeholder="开始时间" :clearable="false"
                    :steps="[1, 30]" :value="formData.startTimeStr"
                    @on-change="onChangeStratTime"></Time-picker>
                </Form-item>
              </i-col>
              <i-col :span="4">
                <Form-item prop="timeLength">
                  <Select placeholder="时长" v-model="formData.timeLength" transfer @on-change="onChangeTimeLength">
                    <Option v-for="item in timeLengthList"
                            :value="item.code" :key="item.code">{{ item.text }}
                    </Option>
                  </Select>
                </Form-item>
              </i-col>
              <i-col :span="6" >
                <Form-item prop="useDate" >
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="生效日期"
                    @on-change="onChangeUseDate" :clearable="false" :value="formData.useDateStr"></Date-picker>
                </Form-item>
              </i-col>
              <i-col :span="2">
                <Button type="info" :loading="loadingCheck" @click="addWorkTime">检查并添加</Button>
              </i-col>
            </Row>
          </Form-item>
        </i-col>
        <i-col :span="24" >
          <Form-item label="已选择" prop="workTimeList" >
            <Row >
              <div v-for="(item, index) in workTimeList" :key="index">
                <Col span="22">
                  <label ><b><template v-if="item.levelTitle">Level：{{ item.levelTitle }}，</template>老师：{{ item.tchId }}-{{ item.tchName}}， 时间：{{ item.weekStr }} {{ item.startTimeStr }}， 时长：{{ item.timeLength }} 分钟，生效日期：{{ item.useDateStr }}</b></label>
                </Col>
                <Col span="2">
                  <Button type="error" size="small" @click="removeWorkTime(index)">删除</Button>
                </Col>
              </div>
            </Row>
          </Form-item>
        </i-col>
        <i-col :span="24">
          <Form-item label="上传截图" prop="attachment">
            <multiple-image-upload :num="10" :defaultFileList="defaultPicList" v-model="formData.attachment" on-file-change="onFileChange"/>
          </Form-item>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingBind" @click="bindWorkTime" >确定</Button>
    </div>
  </Modal>
  <Modal v-model="showDelReasonModal" title="请选择删除原因" :mask-closable="false" width="420">
    <Form :label-width="80">
      <Form-item label="删除原因" required>
        <RadioGroup v-model="pendingDelReason">
          <Radio :label="1">离职老师</Radio>
          <Radio :label="2">关时间老师</Radio>
          <Radio :label="3">淘汰老师</Radio>
          <Radio :label="4">其它</Radio>
          <Radio :label="5">老师请假</Radio>
          <Radio :label="6">教学不好</Radio>
        </RadioGroup>
      </Form-item>
    </Form>
    <div slot="footer">
      <Button type="text" @click="cancelDelReason">取消</Button>
      <Button type="primary" @click="confirmDelReason">确定</Button>
    </div>
  </Modal>
  </div>
</template>
<script>
  export default {
    name: 'BindTchModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      user: {
        type: Object
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let self = this
      return {
        defaultPicList: [],
        visible: this.value,
        timeLengthList: [{code: 25, text: '25'}],
        loadingBind: false,
        loadingCheck: false,
        checkSeq: 0,
        bookMaterialLevelList: null,
        limitMonthTimes: '11111',
        workTimeList: [],
        removeReasonList: [],
        showDelReasonModal: false,
        pendingDelIndex: null,
        pendingDelReason: null,
        formData: {
          attachment: '',
          uid: '',
          nickname: '',
          mobile: '',
          tchId: null,
          tchName: '',
          levelId: null,
          week: '',
          startTime: '',
          timeLength: 25,
          useDate: '',
          schoolId: 0,
        },
        formRule: {
          tchId: [
            {type: 'integer', required: true, message: '请选择老师', trigger: 'change'}
          ],
          week: [
            {type: 'integer', required: true, message: '请选择星期', trigger: 'blur'}
          ],
          startTime: [
            {type: 'integer', required: true, message: '请选择日期', trigger: 'change'}
          ],
          timeLength: [
            {type: 'integer', required: true, message: '请选择时长', trigger: 'change'}
          ],
          useDate: [
            {required: true, message: '请选择生效日期', trigger: 'change'},
            { validator (rule, value, callback, source, options) {
              let errors = []
              let startTime = self.formData.startTime
              if (startTime === '') {
                callback(errors)
                return
              }
              let nowTime = new Date().getTime() / 1000
              if (nowTime >= parseInt(value) + parseInt(startTime)) {
                errors.push('生效日期应在当前日期之后')
                callback(errors)
                return
              }
            } },
          ],
          workTime: [
            { validator (rule, value, callback, source, options) {
              let errors = []
              let workTimeList = self.workTimeList
              let week = self.formData.week
              let startTime = self.formData.startTime
              let timeLength = self.formData.timeLength
              let useDate = self.formData.useDate
              if (week === '' || startTime === '' || timeLength === '' ||
                useDate === '') {
                return
              }
              let endTime = parseInt(startTime) + (parseInt(timeLength) * 60)
              workTimeList.forEach(element => {
                let tmpWeek = element.week
                let tmpStratTime = element.startTime
                let tmpEndTime = parseInt(tmpStratTime) + (parseInt(element.timeLength) * 60)
                if (week === tmpWeek &&
                  ((tmpStratTime < startTime && tmpEndTime > startTime) ||
                  (tmpStratTime < endTime && tmpEndTime > endTime) ||
                  (tmpStratTime >= startTime && tmpEndTime <= endTime))) {
                  errors.push('添加的时间与 ' + element.weekStr + ' ' +
                    element.startTimeStr + ' 冲突')
                }
              })
              callback(errors)
            } },
          ],
          workTimeList: [
          ]
        }
      }
    },
    methods: {
      onFileChange (fileList) {
        this.defaultPicList = fileList
      },
      loadBookMaterialLevel () {
        let self = this
        if (self.bookMaterialLevelList) {
          return
        }
        self.$http.get('/bookMaterialLevel/listByCondition?status=1&ptype=2').then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.bookMaterialLevelList = res.data
        })
      },
      bindCheckParams () {
        let params = Object.assign({}, this.formData)
        let ids = []
        this.removeReasonList.forEach(function (item) {
          if (item && item.tchId != null && ids.indexOf(item.tchId) < 0) {
            ids.push(item.tchId)
          }
        })
        if (ids.length) {
          params.unbindTchIds = ids.join(',')
        }
        return params
      },
      checkTchTimeConflict () {
        let self = this
        let formData = self.formData
        if (!formData.tchId || !formData.week || formData.startTime == null ||
          formData.startTime === '' || !formData.timeLength || !formData.useDate) {
          return
        }
        self.checkSeq++
        let seq = self.checkSeq
        self.$http.get('/bookWordLessonOpenedTime/checkBindTch', {
          params: self.bindCheckParams(),
          silent: true
        }).then(function (res) {
          if (seq !== self.checkSeq) {
            return
          }
          if (!res || res.status !== 'ok' || !res.data) {
            if (res && res.msg) {
              self.$Message.error(res.msg)
            }
          }
        })
      },
      addWorkTime () {
        let self = this
        let isNotError = true
        self.loadingCheck = true
        self.$refs.modalForm.validateField('tchId', (valid) => {
          if (valid !== '') isNotError = false
        })
        self.$refs.modalForm.validateField('week', (valid) => {
          if (valid !== '') isNotError = false
        })
        self.$refs.modalForm.validateField('startTime', (valid) => {
          if (valid !== '') isNotError = false
        })
        self.$refs.modalForm.validateField('timeLength', (valid) => {
          if (valid !== '') isNotError = false
        })
        self.$refs.modalForm.validateField('useDate', (valid) => {
          if (valid !== '') isNotError = false
        })
        self.$refs.modalForm.validateField('workTime', (valid) => {
          if (valid !== '') isNotError = false
        })
        if (!isNotError) {
          self.loadingCheck = false
          return
        }

        self.$http.get('/bookWordLessonOpenedTime/checkBindTch', { params: self.bindCheckParams() }).then(function (res) {
          self.loadingCheck = false
          if (!res) {
            return
          } else if (res && res.data) {
            let buildWorkTime = function () {
              let workTime = {}
              workTime.week = self.formData.week
              workTime.weekStr = self.$constant.weekZh[self.formData.week]
              workTime.startTime = self.formData.startTime
              workTime.startTimeStr = self.formData.startTimeStr
              workTime.timeLength = self.formData.timeLength
              workTime.useDate = self.formData.useDate
              workTime.useDateStr = self.formData.useDateStr
              workTime.tchId = self.formData.tchId
              workTime.tchName = self.formData.tchName
              workTime.levelId = self.formData.levelId
              workTime.levelTitle = self.getLevelName(self.formData.levelId)
              workTime.endDate = res.data.endDate || 0
              self.workTimeList.push(workTime)
            }
            if (res.data.endDate) {
              // 短期固定时间：二次确认弹窗
              let endDateStr = self.$moment(res.data.endDate, 'X').format('YYYY-MM-DD')
              self.$Modal.confirm({
                title: '提示',
                content: '该时间段为短期固定时间，有效期至 ' + endDateStr + '，系统排课截至 ' + endDateStr + '，到期自动解绑无法排课，确认绑定？',
                width: 420,
                okText: '确认绑定',
                loading: true,
                onOk: () => {
                  self.$Modal.remove()
                  if (res.data.message) {
                    self.$Modal.confirm({
                      title: '警告:',
                      content: res.data.message,
                      width: 300,
                      okText: '确认选择',
                      loading: true,
                      onOk: () => {
                        buildWorkTime()
                        self.$Modal.remove()
                      }
                    })
                  } else {
                    buildWorkTime()
                  }
                }
              })
            } else if (res.data.message) {
              self.$Modal.confirm({
                title: '警告:',
                content: res.data.message,
                width: 300,
                okText: '确认选择',
                loading: true,
                onOk: () => {
                  buildWorkTime()
                  self.$Modal.remove()
                }
              })
            } else {
              self.$Message.success('校验通过!')
              buildWorkTime()
            }
          } else {
            self.$Message.error(res.message)
          }
        })
      },
      removeWorkTime (index) {
        let item = this.workTimeList[index]
        // 本次新加未提交条目可直接删；原有已绑定（有 id）必须选删除原因
        if (!item || !item.id) {
          this.workTimeList.splice(index, 1)
          return
        }
        this.pendingDelIndex = index
        this.pendingDelReason = null
        this.showDelReasonModal = true
      },
      cancelDelReason () {
        this.showDelReasonModal = false
        this.pendingDelIndex = null
        this.pendingDelReason = null
      },
      confirmDelReason () {
        if (!this.pendingDelReason) {
          this.$Message.warning('请选择删除原因')
          return
        }
        let index = this.pendingDelIndex
        let item = this.workTimeList[index]
        if (!item) {
          this.cancelDelReason()
          return
        }
        this.removeReasonList.push({
          tchId: item.tchId,
          week: item.week,
          startTime: item.startTime,
          endTime: item.endTime,
          levelId: item.levelId,
          delReason: this.pendingDelReason
        })
        this.workTimeList.splice(index, 1)
        this.cancelDelReason()
      },
      bindWorkTime () {
        let self = this
        self.loadingBind = true
        for (let i = 0; i < self.removeReasonList.length; i++) {
          let reason = self.removeReasonList[i].delReason
          if ([1, 2, 3, 4, 5, 6].indexOf(reason) < 0) {
            self.$Message.warning('请选择删除原因')
            self.loadingBind = false
            return
          }
        }

        let params = {}
        params.uid = self.formData.uid
        params.levelId = self.formData.levelId
        params.workTimeList = self.workTimeList
        params.schoolId = self.formData.schoolId
        params.attachment = self.formData.attachment
        params.removeReasonList = self.removeReasonList
        self.$http.post('/bookWordLessonOpenedTime/addBindTch', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(params)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
          self.loadingBind = false
          if (res.status === 'ok') {
            self.$Message.success(res.data)
            self.visible = false
            if (self.successCallback !== undefined) {
              self.successCallback()
            }
          }
        })
      },
      onChangeStratTime (val) {
        this.formData.startTime = this.$dateUtil.getSecondByHm(val)
        this.formData.startTimeStr = val
        this.checkTchTimeConflict()
      },
      onChangeUseDate (val) {
        this.formData.useDate = val && this.$moment(val, 'YYYY-M-D').format('X')
        this.formData.useDateStr = val
        this.checkTchTimeConflict()
      },
      onChangeWeek (val) {
        this.formData.week = val
        this.checkTchTimeConflict()
      },
      onChangeTimeLength (val) {
        this.formData.timeLength = val
        this.checkTchTimeConflict()
      },
      loadBindTch () {
        let loadMsg = this.$Message.loading({
          content: '正在加载中...',
          duration: 0
        })
        let self = this

        self.$http.get('/bookWordLessonOpenedTime/getBindTch?uid=' + self.formData.uid).then(function (res) {
          loadMsg()
          self.visible = true
          self.limitMonthTimes = res.data.limitMonthTimes
          if (!res || !res.data || res.data.workTimeList.length === 0) {
            return
          }
          let data = res.data
          self.formData.schoolId = data.schoolId
          self.workTimeList = data.workTimeList
          self.removeReasonList = []
          self.workTimeList.forEach(element => {
            element.weekStr = self.$constant.weekZh[element.week]
            element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm')
            element.timeLength = (element.endTime - element.startTime) / 60
            element.useDateStr = self.$moment(element.useDate, 'X').format('YYYY-MM-DD')
            // 逐条时间段携带各自的 levelId，若为空则回退到顶层值
            if (!element.levelId) element.levelId = data.levelId
          })
        })
      },
      getLevelName (levelId) {
        if (!levelId) return ''
        if (!this.bookMaterialLevelList) return levelId
        let item = this.bookMaterialLevelList.find(l => l.id === levelId)
        return item ? item.title : levelId
      },
      onTchSelect (tch) {
        if (tch) {
          this.formData.tchId = tch.id
          this.formData.tchName = tch.firstName + ' ' + tch.lastName
          this.checkTchTimeConflict()
        } else {
          this.formData.tchId = null
          this.formData.tchName = ''
          // 清空老师后不再提示，同时让在途请求失效
          this.checkSeq++
        }
      },
      onClose () {
//        this.formData.levelId = null
//        this.formData.lessonId = null
//        this.formData.tchId = null
//        this.formData.tchFirstName = ''
//        this.formData.tchEmail = ''
//        this.workTimeList = []
//        this.$refs.form.resetFields()
        this.$emit('on-close')
      }
    },
    watch: {
      value (val) {
        if (val === true) {
          this.formData.uid = this.user.id
          this.formData.nickname = this.user.nickname
          this.formData.mobile = this.user.mobile
          this.loadBookMaterialLevel()
          this.loadBindTch()
        } else {
          this.formData = {
            attachment: '',
            uid: '',
            nickname: '',
            mobile: '',
            tchId: null,
            tchName: '',
            levelId: null,
            week: '',
            startTime: '',
            timeLength: 25,
            startTimeStr: '',
            useDate: '',
            useDateStr: '',
            schoolId: 0
          }
          this.workTimeList = []
          this.removeReasonList = []
          this.showDelReasonModal = false
          this.pendingDelIndex = null
          this.pendingDelReason = null
          this.checkSeq++
          this.$refs.modalForm.resetFields()
          this.visible = val
        }
      },
      visible (val) {
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BindTchModal.vue?5164de2b